import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify';
import { auth } from '@/plugins/firebase';
import { onAuthStateChanged } from 'firebase/auth';

let app: ReturnType<typeof createApp> | null = null;

onAuthStateChanged(auth, (user) => {
    if (!app) {
        app = createApp(App);
        app.use(store);
        app.use(router);
        app.use(vuetify);
        app.mount('#app');
    }

    if (user) {
        store.dispatch('auth/setUser', user);
    } else {
        store.dispatch('auth/clearUser');
    }
})
